import { IGroupInfo } from "@home-health-notify/domain";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import { Avatar, Box, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { ChatInfoContext, useTranslation } from "hhn-commons";
import { useContext, useState } from "react";
import {
  DisableEmailText,
  EmailTextFieldWrapper,
  SendEmailComponentStyle,
  SendEmailContainer,
} from "./SendEmail.style";

export const SendEmail = () => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });

  const { chat } = useContext(ChatInfoContext);
  const groupInfo = chat?.chatInfo as IGroupInfo;
  const chatId = groupInfo?.id;

  const email = groupInfo?.email?.email ?? "";
  const enabled = groupInfo?.email?.enabled ?? false;

  const [copyButtonText, setCopyButtonText] = useState(tNs("copy"));
  const [emailCopied, setEmailCopied] = useState(false);

  const onSetEnableDisableFlag = async (chatId: string, enabled: boolean) => {
    const requestData = {
      chatId,
      enable: !enabled,
    };

    await chat?.enableDisableGroupEmail(requestData);
  };

  //Function to Copy email to clipboard and show copied for 5 seconds
  const copyToClipboard = () => {
    const emailBox = document.getElementById("email-box") as HTMLInputElement;

    if (emailBox) {
      emailBox.select();
      navigator.clipboard.writeText(emailBox.value).then(() => {
        setCopyButtonText(tNs("copied"));
        setEmailCopied(true);
        setTimeout(() => {
          setCopyButtonText(tNs("copy"));
          setEmailCopied(false);
        }, 5000); // Restore the original text after 5 seconds
      });
    }
  };

  return (
    <SendEmailComponentStyle>
      <SendEmailContainer>
        <Box
          sx={{ alignItems: "center", display: "flex" }}
          data-testid="send-email"
        >
          <Avatar sx={{ marginRight: "10px" }} variant="rounded">
            <AttachEmailIcon />
          </Avatar>
          <Box>
            <Typography sx={{ fontWeight: "bold" }}>
              {tNs("sendEmailMessage")}
            </Typography>
            <Typography sx={{ opacity: "0.8" }}>
              {tNs("getEmailMessage")}
            </Typography>
          </Box>
        </Box>
        {enabled ? (
          <Box>
            <EmailTextFieldWrapper>
              <TextField
                id="email-box"
                value={email}
                slotProps={{
                  input: {
                    readOnly: true,
                  },
                }}
                size="small"
                sx={{ width: "100%", marginRight: "15px" }}
                data-testid="email-box"
              />
              <Button
                id="copy-notification"
                variant="contained"
                sx={{ fontSize: "small" }}
                onClick={copyToClipboard}
                endIcon={emailCopied ? <CheckIcon /> : null} // Add the icon conditionally
                color="secondary"
              >
                {copyButtonText}
              </Button>
            </EmailTextFieldWrapper>
            <DisableEmailText
              onClick={() => onSetEnableDisableFlag(chatId, enabled)}
              data-testid="disable-email-button"
            >
              <DeleteIcon sx={{ marginRight: "5px" }} />
              {tNs("disableEmail")}
            </DisableEmailText>
          </Box>
        ) : (
          <Button
            variant="contained"
            sx={{ marginTop: "15px", fontSize: "small" }}
            onClick={() => onSetEnableDisableFlag(chatId, enabled)}
            data-testid="enable-email-button"
            color="secondary"
          >
            {tNs("getEmailAddress")}
          </Button>
        )}
      </SendEmailContainer>
    </SendEmailComponentStyle>
  );
};
